import Vue from 'vue'
import DemoBlock from './DemoBlock'
import SwitchVcDemo from './SwitchVcDemo'
import RadioVcDemo from './RadioVcDemo'
import CheckboxVcDemo from './CheckboxVcDemo'
import InputVcDemo from './InputVcDemo'
import InfoVcDemo from './InfoVcDemo'
import NumInputVcDemo from './NumInputVcDemo'
import CarouselVcDemo from './CarouselVcDemo'
import FilterVcDemo from './FilterVcDemo'
import TooltipVcDemo from './TooltipVcDemo'
import TabVcDemo from './TabVcDemo'
import PaginationVcDemo from './PaginationVcDemo'
import RateVcDemo from './RateVcDemo'
import CollapseVcDemo from './CollapseVcDemo'
import SelectVcDemo from './SelectVcDemo'
import MutilSelectVcDemo from './MutilSelectVcDemo'
import SliderVcDemo from './SliderVcDemo'
import DialogVcDemo from './DialogVcDemo'
import ProgressVcDemo from './ProgressVcDemo'
import MsgeifVcDemo from './MsgeifVcDemo'
import SkeletonVcDemo from './SkeletonVcDemo'
import AvatarVcDemo from './AvatarVcDemo'
import ResizeAreaVcDemo from './ResizeAreaVcDemo'
import AlertVcDemo from './AlertVcDemo'
import DrawerVcDemo from './DrawerVcDemo'
import PieVcDemo from './PieVcDemo'
import GridVcDemo from './GridVcDemo'
import FormVcDemo from './FormVcDemo'
import DateVcDemo from './DateVcDemo'
import AsyncComponentVcDemo from './AsyncComponentVcDemo'

Vue.component('DemoBlock', DemoBlock)
Vue.component('SwitchVcDemo', SwitchVcDemo)
Vue.component('RadioVcDemo', RadioVcDemo)
Vue.component('CheckboxVcDemo', CheckboxVcDemo)
Vue.component('InputVcDemo', InputVcDemo)
Vue.component('InfoVcDemo', InfoVcDemo)
Vue.component('NumInputVcDemo', NumInputVcDemo)
Vue.component('CarouselVcDemo', CarouselVcDemo)
Vue.component('FilterVcDemo', FilterVcDemo)
Vue.component('TooltipVcDemo', TooltipVcDemo)
Vue.component('TabVcDemo', TabVcDemo)
Vue.component('PaginationVcDemo', PaginationVcDemo)
Vue.component('RateVcDemo', RateVcDemo)
Vue.component('CollapseVcDemo', CollapseVcDemo)
Vue.component('SelectVcDemo', SelectVcDemo)
Vue.component('MutilSelectVcDemo', MutilSelectVcDemo)
Vue.component('SliderVcDemo', SliderVcDemo)
Vue.component('DialogVcDemo', DialogVcDemo)
Vue.component('ProgressVcDemo', ProgressVcDemo)
Vue.component('MsgeifVcDemo', MsgeifVcDemo)
Vue.component('SkeletonVcDemo', SkeletonVcDemo)
Vue.component('AvatarVcDemo', AvatarVcDemo)
Vue.component('ResizeAreaVcDemo', ResizeAreaVcDemo)
Vue.component('AlertVcDemo', AlertVcDemo)
Vue.component('DrawerVcDemo', DrawerVcDemo)
Vue.component('PieVcDemo', PieVcDemo)
Vue.component('GridVcDemo', GridVcDemo)
Vue.component('FormVcDemo', FormVcDemo)
Vue.component('DateVcDemo', DateVcDemo)
Vue.component('AsyncComponentVcDemo', AsyncComponentVcDemo)
